import { ShieldAlert } from "lucide-react";

interface OrgAccessWarningProps {
  username: string | null;
  githubOrg: string | null;
}

export function OrgAccessWarning({ username, githubOrg }: OrgAccessWarningProps) {
  return (
    <div className="border-border bg-card rounded-lg border p-8">
      <div className="flex flex-col items-center text-center">
        <div className="bg-destructive/10 mb-4 flex size-12 items-center justify-center rounded-full">
          <ShieldAlert className="text-destructive size-6" />
        </div>
        <h3 className="text-lg font-semibold">
          {githubOrg
            ? `${githubOrg} GitHub access required`
            : "GitHub organization access required"}
        </h3>
        <p className="text-muted-foreground mt-2 max-w-lg text-sm">
          Your GitHub account
          {username ? (
            <>
              {" "}
              <span className="text-foreground font-medium">@{username}</span>
            </>
          ) : null}{" "}
          is not a member of the{" "}
          {githubOrg ? (
            <a
              href={`https://github.com/${githubOrg}`}
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium underline underline-offset-2"
            >
              {githubOrg}
            </a>
          ) : (
            <span className="font-medium">required</span>
          )}{" "}
          GitHub organization. Membership is required to create and manage scaffold projects.
        </p>
        <p className="text-muted-foreground mt-3 max-w-lg text-sm">
          Please request access from your organization administrator. Once you&rsquo;ve been added,
          this page will update automatically within about half a minute.
        </p>
      </div>
    </div>
  );
}
